import React, {useEffect, useState} from "react"
import MasterDetail from "../../common/MasterDetail";
import {Button, Col, ControlLabel, FormControl, FormGroup, Grid, Row, Table} from "react-bootstrap";
import {merge} from "../../common/commonHandlers";
import {bindActionCreators} from 'redux'
import createApiService from "../../common/clientActionsBuilder";
import {connect} from "react-redux";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import * as actions from "./EmailDomainsApi";

const api = createApiService('email_domains', 'email_domain', 'Email Domain');

const formatStatus = status => {
    switch (status) {
        case "pending":
            return "Pending";
        case "success":
            return "Success";
        case "failed":
            return "Failed";
        case "temporary_failure":
            return "Temporary failure";
        case "not_started":
            return "Not started";
    }
}

const EmailDomains = ({actions}) => {
    const defaultValues = {domain: ''};
    const [resources, setResources] = useState();
    const [resource, setResource] = useState();
    const [errorMessage, setErrorMessage] = useState();

    const updateResources = resources => {
        setResources(resources)
    };

    useEffect(() => {
        actions.load({}, updateResources);
    }, []);

    useEffect(() => {
        if (resource) {
            setResource(resource);
        }
    }, [resources]);

    const handleSelect = e => {
        setResource(merge(e.resource, defaultValues));
    };

    const reloadResources = resource => {
        setResource(resource);
        actions.load({}, updateResources);
    };

    const validateDomain = domain => {
        if (domain) {
            return {is_valid: true}
        } else {
            return {errorMessage: "Domain can't be blank"}
        }
    }

    const handleRefreshStatus = (id) => {
        if (id) {
            actions.refreshVerificationStatus(id, res => {
                if (id === resource.id) {
                    setResource({...resource, status: res.data.status})
                }
            })
        }
    }

    const updateResourceAttr = e => {
        setResource({...resource, [e.target.name]: e.target.value});
    }

    return (
        resources ?
            <Grid fluid>
                <MasterDetail
                    resourceName="Email Domain"
                    resourceNamePlural="Email Domain"
                    resources={resources}
                    resource={resource}
                    select={handleSelect}
                    save={() => {
                        let validation = validateDomain(resource.domain)
                        if (validation.is_valid) {
                            actions.save(resource, reloadResources, e => {
                                if (e.response.data.message === "Domain already exists") {
                                    setErrorMessage("This domain is already registered in our system. If you're the owner, please contact us at info@treehub.me")
                                }
                                throw e
                            })
                        } else {
                            setErrorMessage(validation.errorMessage)
                        }
                    }}
                    delete={() => actions.remove(resource, x => {
                        setResource(null);
                        actions.load({}, updateResources);
                    })}
                    blockSave={!!resource?.id}
                >
                    {resource &&
                        <div>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <ControlLabel>
                                            Domain
                                        </ControlLabel>
                                        <FormControl
                                            name="domain"
                                            onChange={updateResourceAttr}
                                            value={resource.domain}
                                            disabled={resource.id}
                                        />
                                        {errorMessage &&
                                            <p className="error-message-master-detail ">{errorMessage}</p>}
                                    </FormGroup>

                                    {resource.id && <>
                                        <FormGroup>
                                            <ControlLabel>
                                                Verification Status
                                                <Button bsSize="xs" className="ml-10"
                                                        onClick={() => handleRefreshStatus(resource.id)}>Refresh</Button>
                                            </ControlLabel>
                                            <FormControl
                                                name="status"
                                                value={formatStatus(resource.status)}
                                                disabled
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <ControlLabel>
                                                CNAME Records
                                            </ControlLabel>
                                            <div>
                                                After you’ve created your domain identity, you must
                                                complete the verification process with DKIM authentication by
                                                copying
                                                the following generated CNAME records to publish to your domain’s
                                                DNS
                                                provider. Detection of these records may take up to 72 hours.
                                            </div>
                                            <Table striped fill>
                                                <thead>
                                                <tr>
                                                    <th>Type</th>
                                                    <th>Name</th>
                                                    <th>Value</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {resource.cname_records.map(record =>
                                                    <tr key={record.value}>
                                                        <td>{record.type}</td>
                                                        <td>{record.name}</td>
                                                        <td>{record.value}</td>
                                                    </tr>
                                                )}

                                                </tbody>
                                            </Table>
                                        </FormGroup></>}
                                </Col>
                            </Row>
                        </div>
                    }
                </MasterDetail>
            </Grid> : null);
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...api, ...actions}, dispatch),
});

export default connect(undefined, mapDispatchToProps)(EmailDomains)
